import { RefreshCw } from "lucide-react";

export const FloatingRefresh = ({ onRefresh, refreshing }) => (
  <button
    type="button"
    data-testid="floating-refresh-btn"
    onClick={onRefresh}
    disabled={refreshing}
    title="Reload registrations, approvals and settings"
    className="fixed right-4 bottom-20 sm:bottom-5 z-[70] inline-flex items-center gap-2 rounded-full border border-border bg-white/90 backdrop-blur shadow-2xl px-4 py-2.5 text-xs font-medium text-foreground hover:bg-[#1A2E26] hover:text-white transition-colors disabled:opacity-70"
  >
    <RefreshCw size={14} className={refreshing ? "animate-spin" : ""} /> {refreshing ? "Refreshing…" : "Refresh"}
  </button>
);
